import React, { useEffect, useState } from 'react';
import withRouter from 'umi/withRouter';
import { connect } from 'dva';
import NavBar from '@/components/NavBar';
import styles from './index.less';
import flex from 'umi-hd/lib/flex';

const Map = (props) => {
  const [mapUrl, setMapUrl] = useState('');
  // document.documentElement.setAttribute('data-scale', false);
  // document.documentElement.setAttribute('style', 'font-size:50px');
  // document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1,minimum-scale=1,viewport-fit=cover');
  useEffect(() => {
    const name = props.history.location.query.name;
    const addr = props.history.location.query.addr;
    const coord = props.history.location.query.latitude + ',' + props.history.location.query.longitude; // 39.96554,116.26719
    const key = window.df_sdk_common.DF_CONFIG.DF_MAP_QQ_KEY;
    const url = `https://mapapi.qq.com/web/mapComponents/locationMarker/v/index.html?type=0&init_view=1&marker=coord:${coord};title:${name};addr:${addr}&key=${key}&referer=aaa`;
    setMapUrl(url);
  }, []);
  return (
    <div className={styles.mapWrapper}>
      <NavBar text={props.history.location.query.name} textStyles={{ color: '#999' }} initColor="#2B3C4D" targetColor="#2B3C4D" targetBgColor="#FFF" opacity={1} />
      <div className={styles.map}>
        {
          mapUrl ? <iframe width="100%" height="100%" src={mapUrl} name="东方福利网"></iframe> : null
        }
      </div>
    </div>
  );
};
export default withRouter(connect()(Map));
